<template>

<div id="navigation-container">
  <div id="icon-wrapper">
    <button id="hamburger" 
      v-if="lessThan599"
      @click="displayMenu = true"><font-awesome-icon :icon="['fas', 'bars']" />
    </button>
  </div>
  <div id="menu-wrapper" v-if="!lessThan599 || displayMenu">
    <div id="menu">
      <button id="close"
        v-if="lessThan599 && displayMenu"
        @click="displayMenu = false">
        <font-awesome-icon :icon="['fas', 'xmark']" />
      </button>
      <ul>
        <li class="menu-item">
          <a :href="dia_website + '/pc_entrance.php'">{{ this.$i18n.t("PermanentCollection") }}</a>
        </li>
        <li class="menu-item">
          <a :href="dia_website + '/database.php'">{{ this.$i18n.t("home_database") }}</a>
        </li>
        <li class="menu-item">
          <a :href="dia_website + '/exhibitions/ISL/'">{{ this.$i18n.t("home_exhibitions") }}</a>
        </li>
        <li class="menu-item">
          <a :href="dia_website + '/gai/ISL/'">{{ this.$i18n.t("home_artistic_intro") }}</a>
        </li>
        <li class="menu-item">
          <a :href="dia_website + '/partners.php'">{{ this.$i18n.t("home_partnermuseums") }}</a>
        </li>
        <li class="menu-item">
          <a :href="dia_website + '/hcr_home.php'">{{ this.$i18n.t("timeline_header") }}</a>
        </li>
        <li class="menu-item">
          <router-link :to="{ name: 'home' }">{{ this.$i18n.t("IslDyn_header") }}</router-link>
        </li>
        <li class="menu-item">
          <a :href="mwnf_website + '/mycollection/my_welcome.php'">{{ this.$i18n.t("my_museum") }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

</template>



<script>

import { loadLocaleMessages } from "../i18n.js";
import media from "../mixins/media.js";
export default {
  name: "NavigationComponent",
  props: ["siteLanguage"],
  mixins: [media],
  data() {
    return {
      lessThan599: window.matchMedia("(max-width: 599px)").matches,
      displayMenu: false,
      mwnf_website: process.env.VUE_APP_MWNF_WEBSITE,
      dia_website: process.env.VUE_APP_DIA_WEBSITE,
    }
  },
  watch: {
    "siteLanguage" () {
      loadLocaleMessages(this.siteLanguage);
    }
  },
  mounted () {
    loadLocaleMessages(this.siteLanguage);
  }
}

</script>



<style scoped lang="scss">

#navigation-container {
  width: 100%;
}
  #navigation-container ul {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0;
    width: 100%;
  }
    #navigation-container li {
      @include flex-center;
      font-size: 96%;
      font-weight: 500;
      color: #4C4214;
      line-height: 28px;
      // Make menu items 100% width to distribute evenly
      width: 100%;
    }
      // Alternate menu item colors
      li:nth-child(odd) {
        background-color: $theme-medium-dark;
      }
      li:nth-child(even) {
        background-color: $theme-light;
      }
      #navigation-container a {
        width: 100%;
        color: #4C4214;
        text-decoration: none;
        text-align: center;
        cursor: pointer;
      }

@media only screen and (max-width: 1349px) {
  #navigation-container li {
    font-size: 80%;
  }
}

@media only screen and (max-width: 1249px) {
  // Display two rows of menu items
  #navigation-container ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
    // Fix alternating colors
    li:nth-child(5),
    li:nth-child(7) {
      background-color: $theme-light;
    }
    li:nth-child(6),
    li:nth-child(8) {
      background-color: $theme-medium-dark;
    }
}

@media only screen and (max-width: 1199px) {
  // #navigation-container li {
  //   font-size: 96%;
  // }
}

@media only screen and (max-width: 599px) {
  #navigation-container {
    position: absolute;
    height: 0;
    z-index: 100;
  }
    #icon-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      height: 65px;
      width: 50px;
    }
      #hamburger {
        @include button-styles;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        height: 40px;
        width: 40px;
        color: $text-color;
        font-size: 25px;
        margin-left: 10px;
      }
  #menu-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(black, 0.7);
  }
    #menu {
      @include flex-center;
      flex-direction: column;
      justify-content: flex-start;
      height: 100%;
      width: 50%;
      background-color: $theme-dark;
    }
      #close {
        @include button-styles;
        align-self: flex-end;
        color: $text-color;
        font-size: 24px;
        padding: 10px;
      }
      #navigation-container ul {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
      }
        #navigation-container ul li:first-child {
          border-top: 2px solid $theme-dark;
        }
        #navigation-container li {
          line-height: 35px;
          border-bottom: 2px solid $theme-dark;
        }
        // Fix alternating colors
        li:nth-child(5),
        li:nth-child(7) {
          background-color: $theme-medium-dark;
        }
        li:nth-child(6),
        li:nth-child(8) {
          background-color: $theme-light;
        }
      #database-announcement {
        font-size: 90%;
        background-color: $theme-dark;
        text-align: left;
      }
}

@media only screen and (max-width: 499px) {
  #icon-wrapper {
    height: 75px;
    width: 42px;
  }
    #hamburger {
      height: 30px;
      width: 30px;
      font-size: 20px;
    }
}

@media only screen and (max-width: 399px) {
  #hamburger {
    margin-left: 8px;
  }
  #menu {
    width: 65%;
  }
    #close {
      font-size: 20px;
    }
}

@media print {
  #navigation-container {
    display: none;
  }
}

</style>